module.exports = __webpack_public_path__ + "VIPH5.png?68fd384beaf1088f01f6e8e12d0ad80c";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/colours/horses/VIPH5.png
// module id = 98
// module chunks = 0